import { t } from "i18next";

export class DeviationPriority {
  static LOW = new DeviationPriority(0, t("main.low"), "#2E9C00");
  static MEDIUM = new DeviationPriority(1, t("main.medium"), "#F5A623");
  static HIGH = new DeviationPriority(2, t("main.high"), "#CF2424");
  static ALL = [DeviationPriority.LOW, DeviationPriority.MEDIUM, DeviationPriority.HIGH];

  id: number;
  name: string;
  color: string;

  constructor(id: number, name: string, color: string) {
    this.id = id;
    this.name = name;
    this.color = color;
  }

  static getPriorityWithId(id: number | undefined | null): DeviationPriority | undefined {
    return DeviationPriority.ALL.find((p) => p.id === id);
  }
}

